export enum OtpScreen {
  SEND,
  RESEND,
  VERIFY
}

export class OtpRecipient {
  public contactId: string;
  public name: string;
  public mobilePhone: string;
  public emailAddress: string;
}

export class OtpValidateTokenResponse {
  public responseCode: string;
  public remainingAttempts: number;
  public additionalInfo: any;
}
